module.exports = __webpack_public_path__ + "static/happy-person-raising-one-hand-8ce4075019f34aa71e107ecdc979773e.png";